<template>
  <div class="investment-reg__card-body">
    <div class="investment-reg__card-header">
      Заполни свои данные, чтобы продолжить
    </div>

    <form class="investment-reg__card-form" @submit.prevent="changeUserInfo">
      <UiInput
        v-model.trim="$v.user.lastname.$model"
        title="Фамилия"
        placeholder="Укажите фамилию"
        :error="$v.user.lastname.$dirty && $v.user.lastname.$invalid"
        :popup="
          invalidPopup(
            $v.user.lastname.$dirty,
            $v.user.lastname.$invalid,
            'Обязательное поле'
          )
        "
      />
      <UiInput
        v-model.trim="$v.user.name.$model"
        title="Имя"
        placeholder="Укажите имя"
        :error="$v.user.name.$dirty && $v.user.name.$invalid"
        :popup="
          invalidPopup(
            $v.user.name.$dirty,
            $v.user.name.$invalid,
            'Обязательное поле'
          )
        "
      />
      <UiInput
        v-model.trim="$v.user.email.$model"
        class="fill-row"
        title="Email"
        placeholder="Введите почту"
        :error="$v.user.email.$dirty && $v.user.email.$invalid"
        :popup="
          invalidPopup(
            $v.user.email.$dirty,
            $v.user.email.$invalid,
            'Обязательное поле'
          )
        "
      />
      <UiInput
        v-model.trim="$v.user.phone.$model"
        title="Номер телефона"
        placeholder="Введите номер телефона"
        :error="$v.user.phone.$dirty && $v.user.phone.$invalid"
        :popup="
          invalidPopup(
            $v.user.phone.$dirty,
            $v.user.phone.$invalid,
            'Обязательное поле'
          )
        "
      />
      <UiSelectFilter
        v-model.trim="$v.user.city.$model"
        :option="cityList"
        :smart="true"
        class="-max-height-"
        title="Город"
        placeholder="Город проживания"
        :error="$v.user.city.$dirty && $v.user.city.$invalid"
        :popup="
          invalidPopup(
            $v.user.city.$dirty,
            $v.user.city.$invalid,
            'Обязательное поле'
          )
        "
      />
      <UiInput
        v-model.trim="$v.user.telegram.$model"
        class="fill-row"
        title="Telegram никнейм"
        before="@"
        placeholder="Введите свой Telegram никнейм, прим. @username"
        :error="$v.user.telegram.$dirty && $v.user.telegram.$invalid"
        :popup="tgPopup()"
      />

      <UiCheckbox
        class="fill-row"
        color="#76767B"
        :value="$v.agreed.$model"
        :error="$v.agreed.$dirty && $v.agreed.$invalid"
        :popup="
          invalidPopup(
            $v.agreed.$dirty,
            $v.agreed.$invalid,
            'Обязательное поле'
          )
        "
        @input="setAgreement($event)"
      >
        Я согласен с обработкой моих персональных данных,
        <a
          class="inherited-link"
          href="https://docs.google.com/document/d/1l9I4EyDn7thrLgVAWwM-Eh4r_B5XS-2r-3m6dbZT0J0/edit"
          target="_blank"
          rel="noopener noreferrer"
        >
          Политикой Конфиденциальности
        </a>
        и
        <a
          class="inherited-link"
          href="https://docs.google.com/document/d/1Z4I_yLTtUeJxyKyV8Ps6dcoYHQFZX7_A4sQlG8595pM/edit"
          target="_blank"
          rel="noopener noreferrer"
        >
          Оферты
        </a>
      </UiCheckbox>

      <UiButton color="blue-gray" @click="$emit('alt', 'TelegramPage')">
        У меня нет Telegram
      </UiButton>
      <UiButton :disabled="!canProceed" type="submit"> Продолжить </UiButton>
    </form>
    <div
      class="investment-reg__card-text tg-help"
      @click="$emit('alt', 'TelegramHelp')"
    >
      Как узнать свой никнейм
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

const { mapState } = createNamespacedHelpers('ratingInvestmentsRegistration');
const tg = value => (value ? /^[a-zA-Z0-9_]{5,32}$/.test(value) : true);

export default {
  name: 'ProfilePage',
  data: () => ({}),
  validations: {
    user: {
      name: {
        required
      },
      lastname: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        required
      },
      city: {
        required
      },
      telegram: {
        required,
        tg
      }
    },
    agreed: {
      required
    }
  },
  computed: {
    ...mapState({
      cityList: state => state.data.cityList,
      user: state => state.data.localUser,
      agreed: state => state.data.agreedToTerms
    }),
    canProceed: function () {
      const formValid = !this.$v.user.$invalid;
      const agreementValid = !this.$v.agreed.$invalid && this.agreed;
      return formValid && agreementValid;
    }
  },
  methods: {
    async changeUserInfo() {
      if (this.canProceed) {
        const res = await this.$store.dispatch(
          'ratingInvestmentsRegistration/updateUserInfo'
        );
        if (res) {
          this.$emit('next', 'NichePage');
        }
      }
    },
    invalidPopup(isDirty, isInvalid, errorMessage) {
      if (!isDirty) {
        return;
      }
      if (isInvalid) {
        return {
          msg: errorMessage,
          error: isInvalid
        };
      }
    },
    tgPopup() {
      const tg = this.$v.user.telegram;
      if (!tg.required) {
        return this.invalidPopup(tg.$dirty, tg.$invalid, 'Обязательное поле');
      } else if (!tg.tg) {
        return this.invalidPopup(
          tg.$dirty,
          tg.$invalid,
          'Можно использовать латиницу (a-z), цифры (0-9) и подчеркивание. Минимальная длина - 5 символов'
        );
      }
    },
    setAgreement(agreed) {
      this.$store.dispatch(
        'ratingInvestmentsRegistration/setAgreement',
        agreed
      );
    }
  }
};
</script>
